<template>
  <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
    <el-form-item label="一级目录" prop="catalogue">
      <el-select v-model="ruleForm.catalogue" style="width: 100%">
        <el-option label="普通课程" :value="1"></el-option>
        <el-option label="初级课程" :value="2"></el-option>
        <el-option label="中级课程" :value="3"></el-option>
        <el-option label="高级课程" :value="4"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="课节名称" prop="name">
      <el-input v-model="ruleForm.name"></el-input>
    </el-form-item>
    <el-form-item label="排序" prop="list_order">
      <el-input v-model="ruleForm.list_order"></el-input>
    </el-form-item>
    <el-form-item label="课节" prop="count">
      <el-input v-model="ruleForm.count"></el-input>
    </el-form-item>
    <el-form-item label="上课方式" prop="class_model">
      <el-select v-model="ruleForm.class_model" style="width: 100%" @change="getTestList">
        <el-option label="线上" :value="1"></el-option>
        <el-option label="线下" :value="2"></el-option>
        <el-option label="直播课" :value="3"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="课程类型" prop="type">
      <el-select v-model="ruleForm.type" style="width: 100%">
        <el-option label="理论课" :value="1"></el-option>
        <el-option label="实操课" :value="2"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="考卷分类" prop="paper_cate_id">
      <el-cascader
        v-model="paper_cate_id"
        placeholder="请选择类别"
        :options="options"
        :props="{ checkStrictly: true, label: 'name', value: 'id' }"
        clearable
        @change="changeOption2"
      ></el-cascader>
    </el-form-item>

    <el-form-item v-if="ruleForm.class_model != 3" label="小节测试" prop="paper_uuid">
      <el-select
        v-model="ruleForm.paper_uuid"
        style="width: 100%"
        filterable
        remote
        reserve-keyword
        placeholder="请输入关键词"
        :remote-method="getPaperList"
        :loading="loading"
        @change="changeTest"
      >
        <el-option disabled="disabled" label="1" value="1">
          <div class="option">
            <span>试卷名称</span>
          </div>
        </el-option>
        <el-option v-for="item in paper_list" :key="item.uuid" :label="item.title" :value="item.uuid">
          <div class="option">
            <span>{{ item.title }}</span>
          </div>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-if="ruleForm.class_model == 2" label="上课时间" prop="class_info">
      <p v-for="(item, i) in ruleForm.class_info">
        <span> {{ item.lession_time }} </span>
        <span>{{ item.lession_address }}</span>
        <i class="el-icon-close" @click="removeTime(i)"></i>
      </p>
      <el-button
        v-show="!(Array.isArray(ruleForm.class_info) && ruleForm.class_info.length >= 3)"
        @click="showTimebox = true"
        >添加</el-button
      >
    </el-form-item>
    <el-dialog title="添加上课时间" center :visible.sync="showTimebox" append-to-body :before-close="hideTimeBox">
      <el-form-item label="地点" required="required">
        <el-input v-model="times.lession_address"></el-input>
      </el-form-item>
      <el-form-item label="时间" required="required">
        <el-date-picker
          v-model="times.lession_time"
          style="width: 100%"
          type="datetimerange"
          range-separator="至"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :picker-options="pickerOptions0"
        >
        </el-date-picker>
      </el-form-item>
      <div style="text-align: center">
        <el-button type="primary" @click="addTimes">保存</el-button>
        <el-button @click="hideTimeBox">取消</el-button>
      </div>
    </el-dialog>
    <el-form-item v-if="ruleForm.class_model == 1" label="关联视频" prop="vedio">
      <imgUploads
        v-model="ruleForm.vedio"
        component-id="'img"
        :limit="1"
        :source-type="1"
        @videoDuration="handleVideoDuration"
      ></imgUploads>
    </el-form-item>
    <el-form-item v-if="ruleForm.class_model == 1" label="视频长度(s)" prop="video_long_time">
      <el-input v-model="ruleForm.video_long_time" placeholder="视频上传完自动获取长度" disabled></el-input>
    </el-form-item>
    <el-form-item v-if="ruleForm.class_model == 3" label="关联直播" prop="live_uuid">
      <el-select v-model="ruleForm.live_uuid" style="width: 100%">
        <el-option v-for="(item, index) in livelist" :label="item.title" :value="item.uuid"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label-width="0" style="text-align: center">
      <el-button type="primary" @click="saveCapture('ruleForm')">保存</el-button>
      <el-button @click="$emit('closeBox')">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { addSection, editSection, paperList, paperCateList } from "@/api/edu.js";
import imgUploads from "@/components/pub/supperUpload.vue";
import { getLiveType, addLive, getLiveDetail, editLive, getLiveList, LiveCourse } from "@/api/live.js";

export default {
  components: {
    imgUploads,
  },
  data() {
    return {
      paper_cate_id: "",
      options: [],
      times: {},
      showTimebox: false,
      dates: [],
      loading: false,
      typeList: [],
      captureList: [],
      conditionList: [],
      paper_list: [],
      ruleForm: {
        // cate_uuid: [],
        // course_uuid: this.$route.query.uuid
        video_long_time: ''
      },
      pickerOptions0: {
        disabledDate(time) {
          const three = new Date().getTime() + 180 * 24 * 3600 * 1000;
          // return time.getTime() < Date.now() - 8.64e7;
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > three;
        },
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入课节名称",
            trigger: "blur",
          },
        ],
        vedio: [
          {
            required: true,
            message: "请上传视频",
            trigger: "blur",
          },
        ],
        video_long_time: [
          {
            required: true,
            message: "请等待视频长度获取完成",
            trigger: "blur",
          },
        ],
        list_order: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
        ],
        count: [
          {
            required: true,
            message: "请输入课节数",
            trigger: "blur",
          },
        ],
        class_model: [
          {
            required: true,
            message: "请选择上课方式",
            trigger: "change",
          },
        ],
        class_info: [
          {
            required: true,
            message: "请添加上课时间",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择上课类型",
            trigger: "change",
          },
        ],
        catalogue: [
          {
            required: true,
            message: "请选择一级目录",
            trigger: "change",
          },
        ],
        // paper_uuid: [{

        //     required: true,
        //     message: '关联试卷',
        //     trigger: 'change'
        // }],
        livelist: [],
      },
    };
  },
  mounted() {
    console.log();
    this.getList();
    this.getListCates();
  },
  methods: {
    handleVideoDuration(v) {
      this.ruleForm.video_long_time = v;
    },
    changeOption2(e) {
      console.log(e);
      console.log(e.length);
      if (e.length === 0) {
        this.paper_cate_id = "";
        return;
      }
      this.paper_cate_id = e[e.length - 1];
      console.log(this.paper_cate_id);
      this.getPaperList();
    },
    async getListCates() {
      const param = {
        is_filter: 1,
      };
      this.loading = true;
      const res = await paperCateList(param);
      console.log(res, "sdfsdf");
      this.options = res;
      this.loading = false;
    },
    changeTest(val) {
      console.log(val);
      const it = this.paper_list.find((mi) => {
        return mi.uuid == val;
      });
      console.log(it);
      if (it) {
        this.ruleForm.paper_name = it.title;
      }
    },
    getList() {
      const param = {
        all: 1,
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = LiveCourse(param).then((res) => {
        this.loading = false;
        console.log(res, "livelist");
        if (res instanceof Array) {
          this.livelist = res;
        }
      });
    },
    getTestList(type) {
      this.getPaperList("", type);
      this.ruleForm = { ...this.ruleForm, paper_uuid: "" };
    },
    removeTime(i) {
      this.ruleForm.class_info.splice(i, 1);
    },
    hideTimeBox() {
      this.times = {};
      this.showTimebox = false;
    },
    addTimes() {
      if (Array.isArray(this.ruleForm.class_info)) {
      } else {
        this.$set(this.ruleForm, "class_info", []);
      }
      if (!this.times.lession_address) {
        this.$message.info("请输入地点");
        return;
      }
      if (this.times.lession_time) {
        this.times.lession_time = this.times.lession_time.join(" - ");
      } else {
        this.$message.info("请选择时间");
        return;
      }
      this.ruleForm.class_info.push(this.times);
      this.hideTimeBox();
    },
    saveCapture() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          const data = {
            ...this.ruleForm,
            course_uuid: this.$route.query.uuid,
          };
          this.$emit("subForm", data);
          this.$emit("closeBox");
          return;
          if (this.ruleForm.uuid) {
            this.editSave(data, this.ruleForm.uuid);
          } else {
            this.addSave(data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    initData(row) {
      this.ruleForm = {
        ...row,
        class_info: row.class_info ? JSON.parse(row.class_info) : [],
        vedio: row.vedio ? [row.vedio] : [],
      };
      this.getPaperList(row.title);
    },
    getType() {
      getLiveType().then((res) => {
        console.log(res);
        if (res.data instanceof Array) {
          this.typeList = res.data;
        }
      });
    },
    getPaperList(keyword_search, type) {
      const param = {
        keyword_search,
        paper_type: 1,
        status: 2,
        exam_type: type,
      };
      if (this.paper_cate_id) {
        param.paper_cate_id = this.paper_cate_id;
      }
      paperList(param).then((res) => {
        if (res.data instanceof Array) {
          this.paper_list = res.data;
        }
      });
    },
    editSave(data, uuid) {
      editSection(data, uuid).then((res) => {
        if (res) {
          this.$message.success("编辑成功");

          this.$emit("getList");
          this.$emit("closeBox");
        }
      });
    },
    addSave(data) {
      addSection(data).then((res) => {
        console.log(res);
        if (res) {
          this.$message.success("新增成功");

          this.$emit("getList");
          this.$emit("closeBox");
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            ...this.ruleForm,
            // cate_uuid: this.ruleForm.cate_uuid,
            // start_time: this.ruleForm.dates[0],
            // end_time: this.ruleForm.dates[1],
            is_charge: this.ruleForm.price ? 1 : 2,
          };
          if (this.ruleForm.uuid) {
          } else {
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped="scoped" lang="less">
p {
  background-color: #f5f5f5;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  margin-bottom: 10px;
}
.option {
  display: flex;

  & > span {
    width: 50%;
  }
}
</style>
